"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var React = tslib_1.__importStar(require("react"));
var ChevronDown_1 = tslib_1.__importDefault(require("@eduzz/houston-icons/ChevronDown"));
var Popover_1 = tslib_1.__importDefault(require("../../Popover"));
var usePopover_1 = tslib_1.__importDefault(require("../../Popover/usePopover"));
var nestedComponent_1 = tslib_1.__importDefault(require("../../utils/nestedComponent"));
var Fieldset_1 = tslib_1.__importDefault(require("../_utils/Fieldset"));
var withForm_1 = tslib_1.__importDefault(require("../Form/withForm"));
var context_1 = tslib_1.__importDefault(require("./context"));
var Option_1 = tslib_1.__importDefault(require("./Option"));
var SelectField = function (_a) {
    var id = _a.id, label = _a.label, value = _a.value, size = _a.size, placeholder = _a.placeholder, loading = _a.loading, multiple = _a.multiple, renderValue = _a.renderValue, onChange = _a.onChange, disabled = _a.disabled, startAdornment = _a.startAdornment, errorMessage = _a.errorMessage, fullWidth = _a.fullWidth, helperText = _a.helperText, className = _a.className, emptyOption = _a.emptyOption, optionsProps = _a.options, children = _a.children;
    var _b = (0, usePopover_1.default)(), openPopover = _b.openPopover, closePopover = _b.closePopover, isPopoverOpened = _b.isPopoverOpened, popoverTargetProps = _b.popoverTargetProps, popoverProps = _b.popoverProps;
    var _c = tslib_1.__read(React.useState([]), 2), options = _c[0], setOptions = _c[1];
    value = !multiple ? value : Array.isArray(value) ? value : [];
    var contextRegisterOption = React.useCallback(function (option) {
        setOptions(function (options) { return tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(options), false), [option], false); });
        return function () { return setOptions(function (options) { return options.filter(function (op) { return op !== option; }); }); };
    }, []);
    var contextOnSelect = React.useCallback(function (selected) {
        if (!multiple) {
            onChange && onChange(selected);
            closePopover();
            return;
        }
        var isEmptyOption = selected === null || selected === undefined || selected === '';
        var newValue = isEmptyOption
            ? []
            : value.includes(selected)
                ? value.filter(function (v) { return v !== selected; })
                : tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(value), false), [selected], false);
        onChange && onChange(newValue);
    }, [multiple, onChange, value, closePopover]);
    var contextValue = React.useMemo(function () { return ({
        registerOption: contextRegisterOption,
        onSelect: contextOnSelect,
        inputSize: size,
        multiple: multiple !== null && multiple !== void 0 ? multiple : false,
        inputValue: value
    }); }, [contextOnSelect, contextRegisterOption, multiple, size, value]);
    var text = React.useMemo(function () {
        var _a, _b, _c;
        if (renderValue)
            return renderValue(value);
        if (!multiple) {
            return (_c = (_b = (_a = options.find(function (o) { var _a; return (value !== null && value !== void 0 ? value : '') === ((_a = o.value) !== null && _a !== void 0 ? _a : ''); })) === null || _a === void 0 ? void 0 : _a.text) !== null && _b !== void 0 ? _b : placeholder) !== null && _c !== void 0 ? _c : '';
        }
        if (value.length > 3) {
            return "".concat(value.length, " selecionados");
        }
        return (options
            .filter(function (o) { return value.includes(o.value); })
            .map(function (o) { return o.text; })
            .join(', ') ||
            placeholder ||
            '');
    }, [multiple, options, placeholder, renderValue, value]);
    return ((0, jsx_runtime_1.jsxs)(context_1.default.Provider, tslib_1.__assign({ value: contextValue }, { children: [(0, jsx_runtime_1.jsxs)(Popover_1.default, tslib_1.__assign({}, popoverProps, { placement: 'bottom', fullWidth: true, keepMounted: true }, { children: [children, !!emptyOption && (0, jsx_runtime_1.jsx)(Option_1.default, { label: emptyOption }), optionsProps === null || optionsProps === void 0 ? void 0 : optionsProps.map(function (option, index) {
                        var _a;
                        return ((0, jsx_runtime_1.jsx)(Option_1.default, { value: option.value, label: option.label, disabled: option.disabled }, (_a = option.value) !== null && _a !== void 0 ? _a : "op-".concat(index)));
                    })] })), (0, jsx_runtime_1.jsx)(Fieldset_1.default, tslib_1.__assign({ containerRef: popoverTargetProps.ref, label: label, size: size, loading: loading, className: className, focused: isPopoverOpened, errorMessage: errorMessage, fullWidth: fullWidth, endAdornment: (0, jsx_runtime_1.jsx)(ChevronDown_1.default, {}), startAdornment: startAdornment, helperText: helperText, disabled: disabled, onClickContainer: !disabled && !loading ? openPopover : undefined }, { children: (0, jsx_runtime_1.jsx)("div", tslib_1.__assign({ id: id, className: 'hst-input-text' }, { children: text })) }))] })));
};
/**
 * @deprecated Use Select from @eduzz/houston-forms or Antd
 */
exports.default = (0, nestedComponent_1.default)((0, withForm_1.default)(React.memo(SelectField)), {
    Option: Option_1.default
});
